import Model from './Model';

export default class WorkingArea extends Model {
    name;

    static apiPath() {
        return 'working-areas';
    }
}



// WEBPACK FOOTER //
// ./src/models/WorkingArea.js